import { ApiError } from "@vana/core";

export class GetRefundError extends ApiError {}
export class GetBenefitError extends ApiError {}
export class NotifyBenefitError extends ApiError {}
export class UnnotifyBenefitError extends ApiError {}
export class ConfirmFirstPurchaseError extends ApiError {}
